import React from 'react';
import { Formik } from 'formik';
import Form from './components/Form';
import Progress from 'components/Progress';
import { storyModel } from './models';
import { Redirect } from 'react-router';
import Snackbar from '@material-ui/core/Snackbar';
import links from 'utils/links';

import { createLinkTitle } from 'utils/';

class Presenter extends React.Component {
  state = {
    redirect: false,
    redirectionMessage: ""
  }
  componentDidMount() {
    const { props } = this;
    const { slug } = props.match.params;
    if (slug) {
      props.fetchStoryByTitle(slug);
    }
    props.fetchCities();
    props.fetchCuisines();
    props.fetchEateries();
    props.fetchTags();

    window.addEventListener('beforeunload', this.handleWindowBeforeUnload);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleWindowBeforeUnload);
  }

  componentDidUpdate(prevProps) {
    if (!this.props.derived.isSaving && prevProps.derived.isSaving) {
      let self = this;
      if (this.props.derived.editedSlug.draft) {
        this.setState({
          redirect: true,
          redirectionMessage: "Your Draft Saved Successfully! Redirecting to Dashboard"
        })
        setTimeout(function () {
          self.props.history.push(links.contributorDashboardLink());
        }, 2000);
      }
      else if (this.props.derived.editedSlug.id) {
        this.setState({
          redirect: true,
          redirectionMessage: "Successfully updated the story! Redirecting to Dashboard"
        })
        setTimeout(function () {
          self.props.history.push(links.contributorDashboardLink());
        }, 2000);
      }
      else {
        this.setState({
          redirect: true,
          redirectionMessage: "Successfully added the story! Redirecting to Dashboard"
        })
        setTimeout(function () {
          self.props.history.push(links.contributorDashboardLink());
        }, 2000);
      }
    }
  }

  isLoading = () => {
    const { slug } = this.props.match.params;
    const {
      cities,
      cuisines,
      dishTags,
      story
    } = this.props.derived;
    return !(
      cities.length &&
      cuisines.length &&
      dishTags.length &&
      (!slug || story)
    );
  };

  getInitialValues = () => {
    const { story } = this.props.derived;
    let storyTitle = "", storyCities = [], storyCuisines = [], storyDishes = [], storyContent = '\n', storyLocality = "", storyMainImage = null, storyMainImageCredit = "", storyMainImageName = "", storySummary = "";
    if (story.title) {
      storyCities = story.city.map((city) => ({ value: city.id.toString(), label: city.name }));
      storyCuisines = story.cuisines.map((cuisine) => ({ value: cuisine.id.toString(), label: cuisine.name }));
      storyDishes = story.dishes.map((dish) => ({ value: dish.id.toString(), label: dish.name }));
      storyContent = story.content;
      storyLocality = story.location.locality;
      storyMainImage = story.mainImage.uri;
      storyMainImageCredit = story.mainImage.picCredits;
      storyMainImageName = story.mainImage.name;
      storySummary = story.summary;
      storyTitle = story.title;
    }
    return {
      id: story.id,
      isPreview: false,
      isDraft: false,
      isSaving: false,
      title: storyTitle,
      featuredImage: {
        file: null,
        uri: storyMainImage,
        photoCredit: storyMainImageCredit,
        name: storyMainImageName
      },
      summary: storySummary,
      cities: storyCities,
      locality: storyLocality,
      cuisines: storyCuisines,
      dishes: storyDishes,
      eateries: [],
      content: storyContent,
    };
  };

  handleWindowBeforeUnload = e => {
    e.preventDefault();
    e.returnValue = '';
  };

  handleSubmit = (values, { setSubmitting }) => {
    if (!values.isPreview && !values.isSaveToDraft) {
      values.isPreview = true;
      setSubmitting(false);
      window.scrollTo(0, 0);
    } else {
      const { derived } = this.props;
      let isDerivedDraft = derived.story ? derived.story.draft : false;
      const editedStory = {
        ...(derived.story || {}),
        ...storyModel.toModel(values),
        linkTitle: (values.id && !isDerivedDraft) ? derived.story.linkTitle : createLinkTitle(values.title),
      };
      if (values.isSaveToDraft) {
        values.isSaveToDraft = false;
      } else {
        this.shouldRedirect = false;
      }
      this.props.upsertStory(editedStory);

      setSubmitting(false);
    }
  };

  validate = values => {
    const errors = {};
    if (!values.featuredImage.file && !values.featuredImage.uri) {
      errors.featuredImage = 'Content must not be empty.';
    }
    if (values.cities.length === 0) {
      errors.cities = 'Require at least one city.';
    }
    if (values.cuisines.length === 0) {
      errors.cuisines = 'Require at least one cuisine.';
    }
    if (values.content === '\n') {
      errors.content = 'Content must not be empty.';
    }
    return errors;
  };

  render() {
    const { derived } = this.props;
    const showProgress = this.isLoading() || derived.isSaving;
    return (
      <div className="flex justify-center">
        <Progress
          dialog={derived.isSaving}
          message="Loading…"
          show={showProgress || !!(this.shouldRedirect && derived.editedSlug)}
        />
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={this.state.redirect}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={this.state.redirectionMessage}
        />
        {!showProgress ? (
          this.shouldRedirect && derived.editedSlug ? (
            <Redirect push to={`/story/${derived.editedSlug}`} />
          ) : (
              <div className="max-w-sm w-screen p-4 sm-p-6 sm-mt-12 sm-mb-12 bg-white shadow">
                <Formik
                  initialValues={this.getInitialValues()}
                  onSubmit={this.handleSubmit}
                  render={props => (
                    <Form {...props} derived={this.props.derived} />
                  )}
                  validate={this.validate}
                />
              </div>
            )
        ) : null}
      </div>
    );
  }
}

export default Presenter;
